import { createStyles, makeStyles } from '@material-ui/core/styles';
import { BLACK } from 'constants/colors';
export default makeStyles(theme => createStyles({
  infoList: {
    marginTop: theme.spacing(4),
    '& a': {
      color: BLACK,
      textDecoration: 'underline'
    }
  }
}));